import { env } from 'src/config/env';
import { useSyncExternalStore } from 'react';
import { isDebugMode } from 'src/contexts/DebugContext';
import {
  isFamilyGroupReady,
  subscribeFamilyGroupReadiness,
} from 'src/modules/analytics/posthogClient';

// True once this session pushed the current family's group properties to PostHog. A family-bucketed
// flag answered before that lands on `control`, so gates treat it as loading.
export const useFamilyGroupPropertiesReady = (): boolean => {
  const ready = useSyncExternalStore(subscribeFamilyGroupReadiness, isFamilyGroupReady);
  return ready || !!env.isCi || isDebugMode();
};
